import { render, staticRenderFns } from "./ScreenCanvas.vue?vue&type=template&id=e62846ca&scoped=true"
import script from "./ScreenCanvas.vue?vue&type=script&lang=ts"
export * from "./ScreenCanvas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62846ca",
  null
  
)

export default component.exports